import { CircularProgress } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { HeaderSpacer } from '../components/Header';
import SiteHeroPage from '../components/SiteHeroPage';
import { fetchSiteById } from '../redux/features/sites/sitesSlice';
import { selectContext } from '../redux/features/context/contextSlice';
import StyledBackdrop from '../components/StyledBackdrop';
import Login from '../components/Login';

export default function SiteUpdateView() {
  const { siteId } = useParams();

  const dispatch = useDispatch();
  const context = useSelector(selectContext);
  const { userInfo } = useSelector((state) => state.users);

  const loadSite = useCallback(
    () => dispatch(fetchSiteById({ namespace: 'private', siteId })),
    [dispatch, siteId],
  );

  useEffect(() => {
    if (userInfo && siteId) loadSite();
  }, [loadSite, userInfo, siteId]);

  const site = context && context.site;
  const isSiteLoaded = site && site.id === siteId && (site.privateData || site.publicData);

  return (
    <>
      <HeaderSpacer />
      { !userInfo && <Login />}
      { userInfo && !isSiteLoaded && (
        <StyledBackdrop open={!isSiteLoaded}>
          <CircularProgress color="inherit" />
        </StyledBackdrop>
      )}
      { userInfo && isSiteLoaded && (
        <SiteHeroPage
          site={site}
          namespace="private"
          onRefetch={loadSite}
          startInEdit
        />
      )}
    </>
  );
}
